export default __webpack_public_path__ + "static-front/media/PlusIcon.7d195d7d.svg";